export default {
  "typeHere" : "type here",
  "voice" : "Voice"
}



// WEBPACK FOOTER //
// ./src/locales/en.js